import { jsx as n } from "react/jsx-runtime";
import { DayPicker as _ } from "react-day-picker";
import { getDefaultOptions as s } from "date-fns";
import { ChevronLeftIcon as e } from "../../icons/ChevronLeftIcon.js";
import { ChevronRightIcon as a } from "../../icons/ChevronRightIcon.js";
import { formatWeekdayName as c } from "./utils/formatWeekdayName.js";
import '../../_assets/Datepicker.BPfciZqS.css';const i = "_root_1swnh_44", h = "_months_1swnh_54", r = "_nav_1swnh_58", d = "_button_previous_1swnh_66", m = "_button_next_1swnh_67", u = "_month_1swnh_54", l = "_month_grid_1swnh_94", w = "_month_caption_1swnh_122", p = "_caption_label_1swnh_130", b = "_weekday_1swnh_146", f = "_day_1swnh_152", y = "_selected_1swnh_159", v = "_disabled_1swnh_159", k = "_outside_1swnh_162", g = "_day_button_1swnh_185", x = {
  root: i,
  months: h,
  nav: r,
  button_previous: d,
  button_next: m,
  month: u,
  month_grid: l,
  month_caption: w,
  caption_label: p,
  weekday: b,
  day: f,
  selected: y,
  disabled: v,
  outside: k,
  day_button: g,
  "slide-in-out": "_slide-in-out_1swnh_1",
  "fade-in-out": "_fade-in-out_1swnh_1"
}, D = s().locale, C = (t) => {
  const { orientation: o } = t;
  return o === "left" ? /* @__PURE__ */ n(e, { ...t }) : /* @__PURE__ */ n(a, { ...t });
}, R = ({ locale: t = D, ...o }) => /* @__PURE__ */ n(
  _,
  {
    ...o,
    locale: t,
    classNames: x,
    showOutsideDays: !0,
    formatters: {
      formatWeekdayName: c
    },
    components: {
      Chevron: C
    }
  }
);
export {
  R as Datepicker
};
